// These are the IDs for the organisations whose members we should no track on FullStory
export const FS_IGNORED_ORGANISATION_IDS = [1];

// Default timezone used in CSV creation
export const DEFAULT_TIMEZONE = "Europe/London";
